import { render, staticRenderFns } from "./AtomSkipToContentButton.vue?vue&type=template&id=1ca276c0&scoped=true"
import script from "./AtomSkipToContentButton.vue?vue&type=script&lang=js"
export * from "./AtomSkipToContentButton.vue?vue&type=script&lang=js"
import style0 from "./AtomSkipToContentButton.vue?vue&type=style&index=0&id=1ca276c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca276c0",
  null
  
)

export default component.exports